<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="meeting_date" slot-scope="{ item }">
            {{ item.meeting_date | datetime }}
        </template>

        <template slot="meeting_description" slot-scope="{ item }">
            <a href="#" @click.prevent="seeDetails(item)">
                {{ item.meeting_description | elipsis(100) }}
            </a>
        </template>

        <template slot="actions" slot-scope="data">
            <b-button size="sm" variant="primary" @click="seeDetails(data.item)"><i class="fa fa-search-plus"></i></b-button>
            <b-button size="sm" v-if="data.item.draft" variant="primary" @click="updateReport(data.item)"><i class="fa fa-pencil"></i></b-button>
            <b-button size="sm" variant="primary" @click="addPhotos(data.item)"><i class="fa fa-camera" aria-hidden="true"></i></b-button>
            <b-button v-if="!data.item.draft" size="sm" variant="primary" title="Compartir" @click="addWatchers(data.item)"><i class="fa fa-share-alt"></i></b-button>
            <b-button size="sm" variant="danger" @click="removeReport(data.item)"><i class="fa fa-trash"></i></b-button>
        </template>
    </app-data-table>
</template>
<script>
import fields from './fields';
export default {
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            fields: fields
        }
    },
    methods: {
        onChangePage(page){
            this.$emit('change-page', page);
        },
        updateReport(data){
            this.$emit('update-report', data);
        },
        removeReport(data){
            this.$emit('remove-report', data);
        },
        seeDetails(data){
            this.$emit('see-details-report', data);
        },
        addPhotos(data){
            this.$emit('add-photos-report', data);
        },
        onSort(ctx) {
            this.$emit('sort', ctx);
        },
        addWatchers(data){
            this.$emit('add-watchers', data);
        },
    }
}
</script>
<style scoped>
    .details {
        cursor: pointer;
    }
</style>